module.exports = __webpack_public_path__ + "img/aston-blog.4a2eefca.webp";